import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import FacetsBlock from '../filings/FacetsBlock/FacetsBlock';
import '../filings/filings.less';
import Notification from '../../components/common/Notification';

import AdvancedSearchTab from '../../components/advancedSearch/AdvancedSearchTab';
import GeneralBankruptcyForm from '../../components/advancedSearch/initialForms/bankruptcy/GeneralForm';
import CasesBankruptcyForm from '../../components/advancedSearch/initialForms/bankruptcy/CasesForm';
import PetitionsBankruptcyForm from '../../components/advancedSearch/initialForms/bankruptcy/PetitionsForm';
import SchedulesBankruptcyForm from '../../components/advancedSearch/initialForms/bankruptcy/SchedulesForm';
import { parseQueryStringToObject } from '../../redux/actions/advancedSearchAction';
import KnowledgeBaseLink from '../../components/advancedSearch/KnowledgeBaseLink';

const pages = {
  general: {
    title: 'Advanced Search',
    component: GeneralBankruptcyForm,
  },
  cases: {
    title: 'Advanced Search',
    component: CasesBankruptcyForm,
  },
  petitions: {
    title: 'Petitions',
    component: PetitionsBankruptcyForm,
  },
  schedules: {
    title: 'Schedules',
    component: SchedulesBankruptcyForm,
  },
};

const AdvancedSearchIR = props => {
  const { location } = props;
  const queryObject = parseQueryStringToObject(location.search);
  const { courtType, tab } = props.match.params;
  const selectedPage = pages[tab] || pages.general;
  const SelectedForm = selectedPage.component;

  const selectedCls = segment =>
    tab === segment ? 'ui-state-default ui-tabs-selected ui-state-active' : 'ui-state-default';

  return (
    <div className="filings filings-page">
      <Notification />
      <FacetsBlock type="advanced-search" />

      <div className="filings-forms">
        <KnowledgeBaseLink />
        <h1 className="title">{selectedPage.title || 'Advanced Search'}</h1>

        {['general', 'cases'].includes(tab) && (
          <ul className="ui-tabs-nav ui-helper-reset ui-helper-clearfix filings-forms-tabs">
            <li className={selectedCls('general')}>
              <Link to={`/advanced-search/${courtType}/general`}>
                <span>General</span>
              </Link>
            </li>
            <li className={selectedCls('cases')}>
              <Link to={`/advanced-search/${courtType}/cases`}>
                <span>Cases</span>
              </Link>
            </li>
          </ul>
        )}
        <div className="inside-block ui-tabs-panel ui-widget ui-widget-content ui-corner-bottom">
          <AdvancedSearchTab
            history={props.history}
            courtType={courtType}
            tab={tab}
            queryParams={queryObject}
            InitialForm={SelectedForm}
          />
        </div>
      </div>
    </div>
  );
};

AdvancedSearchIR.propTypes = {
  match: PropTypes.any.isRequired,
  history: PropTypes.any.isRequired,
  location: PropTypes.any.isRequired,
};

AdvancedSearchIR.defaultProps = {};

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdvancedSearchIR));



// WEBPACK FOOTER //
// ./src/pages/advancedSearch/AdvancedSearchIR.jsx